import { render } from "./VarValue.vue?vue&type=template&id=fac6728a&scoped=true"
import script from "./VarValue.vue?vue&type=script&lang=js"
export * from "./VarValue.vue?vue&type=script&lang=js"

import "./VarValue.vue?vue&type=style&index=0&id=fac6728a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac6728a"]])

export default __exports__